import Vue from 'vue'

export default ({ ls }) => {
  return new Vue({
    data () {
      return {
        instance: false
      }
    },
    methods: {
      load () {
        return new Promise(resolve => {
          if (ls.get('_ignore_stripe')) resolve(null)
          if (this.instance) resolve(this.instance)
          else {
            let documentTag = document, tag = 'script',
              object = documentTag.createElement(tag),
              scriptTag = documentTag.getElementsByTagName(tag)[0]
            object.src = '//js.stripe.com/v3'
            object.addEventListener('load', () => {
              this.instance = window.Stripe
              resolve(window.Stripe)
            }, false)

            scriptTag.parentNode.insertBefore(object, scriptTag)
          }
        })
      }
    }
  })
}

